import * as types from "../actions/actionTypes";
import initialState from "../store/initialState";
import mergeDeep from '../util/mergeDeep';

export function beadReducer(state = initialState.beads, action) {
	switch (action.type) {
		case types.BEADS_LOADED: {
			return action.body.map(x => mergeDeep({}, x));
		}

		default:
			return state;
	}
}

export function voortgangsrapportBeadReducer(state = initialState.voortgangsrapportBeads, action) {
	switch (action.type) {
		case types.VOORTGANGSRAPPORT_BEADS_LOADED: {
			return action.body;
		}

		default:
			return state;
	}
}